const errorFormatter = (error) => {
  return (error && error.message)
    ? error.message
    : 'Something went wrong';
}

const secureFetch = async (url, opts) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await window.fetch(url, {
        ...opts,
        mode: 'cors'
      });

      return response.ok
        ? resolve(response)
        : (async () => {
          const result = await response.json();
          reject(errorFormatter(result.error));
        })();
    } catch (e) {
      return reject(errorFormatter(e));
    }
  });
}

export const uploadImage = async ({ url, body }) => {
  const response = await secureFetch(url, {
    method: 'POST',
    body
  });

  return await response.json();
}

export const createStorageParams = async ({ endpoint, headers }) => {
  const response = await secureFetch(`${endpoint}/custom/note-images/storage-parameters`, {
    headers,
    method: 'POST'
  });

  return await response.json();
}

export const getNoteGraphic = async ({ endpoint, headers, noteResourceId }) => {
  const response = await secureFetch(`${endpoint}/custom/notes/${noteResourceId}/graphic`, {
    headers,
    method: 'GET'
  });

  return await response.text();
}

export const getNote = async ({ endpoint, headers, noteResourceId }) => {
  const response = await secureFetch(`${endpoint}/custom/notes/${noteResourceId}`, {
    headers,
    method: 'GET',
  });

  return await response.json();
}

export const saveNote = async ({ endpoint, headers, body }) => {
  const response = await secureFetch(`${endpoint}/custom/notes`, {
    headers,
    method: 'POST',
    body,
  });

  return await response.json();
}

export const updateNote = async ({ endpoint, headers, body, id }) => {
  const response = await secureFetch(`${endpoint}/custom/notes/${id}`, {
    headers,
    method: 'PATCH',
    body
  });

  return await response.json();
}

export const getColors = async ({ endpoint, headers }) => {
  const response = await secureFetch(`${endpoint}/custom/note-font-colors`, {
    headers,
    method: 'GET'
  });

  return await response.json();
}

export const getFonts = async({ endpoint, headers }) => {
  const response = await secureFetch(`${endpoint}/custom/note-fonts`, {
    headers,
    method: 'GET'
  });

  return await response.json();
}
